import {createAction, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {getActionName} from "../utils/getActionName";
import {SessionStatus, SignInError} from "./auth.interface";

const sliceName = 'auth';

export interface AuthStore {
    status: SessionStatus;
    email: string | null;
    signInError: SignInError | null;
}

const initialState: AuthStore = {
    status: 'unknown',
    email: null,
    signInError: null,
}

const authSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setSession(state: AuthStore, action: PayloadAction<string>) {
            state.status = 'authenticated';
            state.email = action.payload;
            state.signInError = null;
        },
        clearSession(state: AuthStore) {
            state.status = 'anonymous';
            state.email = null;
        },
        setSignInError(state: AuthStore, action: PayloadAction<SignInError>) {
            state.status = 'anonymous';
            state.email = null;
            state.signInError = action.payload;
        },
    }
});

export const authReducer = authSlice.reducer;
export const authActions = {
    ...authSlice.actions,
    loadSession: createAction(getActionName(sliceName, 'loadSession')),
    signInWithGoogle: createAction<string>(getActionName(sliceName, 'signInWithGoogle')),
    signOut: createAction(getActionName(sliceName, 'signOut')),
}
